module.exports = __webpack_public_path__ + "img/gong.3738eefa.png";